import { render, staticRenderFns } from "./OfficeCreate.vue?vue&type=template&id=08b8de01&scoped=true&"
import script from "./OfficeCreate.vue?vue&type=script&lang=js&"
export * from "./OfficeCreate.vue?vue&type=script&lang=js&"
import style0 from "./OfficeCreate.vue?vue&type=style&index=0&id=08b8de01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b8de01",
  null
  
)

export default component.exports